export enum CompetitionCategoryId {
  League = 1,
  Cup = 2,
  Tournament = 3,
  IndoorTournament = 4,
  Relegation = 5,
  Testmatches = 6,
}

export default class CompetitionCategory {
  private readonly id: number;
  private readonly name: string;

  constructor({id, name}: {id: number; name: string}) {
    this.id = id;
    this.name = name;
  }

  isTestmatch = () => {
    return this.id === CompetitionCategoryId.Testmatches;
  };

  isLeague() {
    return this.id === CompetitionCategoryId.League;
  }

  isRelegation = () => {
    return this.id === CompetitionCategoryId.Relegation;
  };
}
